<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                tenant_id: '',
                type_id: 2,
                concept: '',
                number: '',
                service_id: '',
                serv_id: '',
                service_type: '',
                file: '',
                xml: '',
                folio: '',
                company_id: '',
                amount: '',
                payment_method: 'PPD',
                currency_id: 1,
                change_date: '',
                exchange_rate: '',
                amount_usd: '',
                json_items: [],
                group_bill: 0,
                from: '',
            },
            cataloguePays: [],
            servicesExtras: [],
            file: '',
            fileName: '',
            xml: '',
            xmlName: '',
            tenant: {},
            service_type: '',
            send: false,
            load: false,
        }
    },
    async mounted() {
        this.catalogue.getCurrencies();
        // this.catalogue.get_types_bill_number();
    },
    methods: {
        getTotal() {
            let total = 0;
            this.form.json_items.forEach(item => {
                total += item.amount * 1;
            });
            this.form.amount = total;
        },
        addJsonItems(id,
            name,
            type,
            sub_total,
            iva,
            ieps,
            isr_ret,
            iva_ret,
            discount,
            amount) {
            let json_items_all = this.form.json_items;
            let json_items = {
                'service_id': id,
                'name': name,
                'type': type,
                'sub_total': sub_total,
                'iva': iva,
                'ieps': ieps,
                'isr_ret': isr_ret,
                'iva_ret': iva_ret,
                'discount': discount,
                'amount': amount
            };
            console.log('json_items');
            console.log(json_items);
            json_items_all.push(json_items);
            this.form.json_items = json_items_all;

        },
        calcTotalUSD() {
            this.form.amount = this.form.exchange_rate * this.form.amount_usd;
        },
        dataPay(id = 0) {
            console.log(id);
            let concept = '';
            let data = this.tenant;
            this.form.json_items = [];

            let nowDate = this.moment(data.star_date);
            let dateConcept = nowDate.format('MMMM [de] YYYY');

            if (id == 0) {
                if (data.department) {
                    concept += `Renta ${data.department.number} en la planta ${data.department.level}`;
                }
                concept += ` del mes de ${dateConcept}`;
                this.form.serv_id = 0;
                this.form.service_type = 1;
                if (this.tenant.currency_id == 2) {
                    if (this.tenant.invoice_issued == 2) {
                        this.form.amount = data.amountR;
                    } else {
                        this.form.amount_usd = data.amount;
                    }
                }

                const objetoEspecificos = this.servicesExtras.filter(item => item.pivot.group_bill == 1);

                objetoEspecificos.forEach(item => {
                    this.addJsonItems(
                        data.id,
                        item.name,
                        2,
                        item.pivot.subtotal,
                        item.pivot.iva,
                        item.pivot.ieps,
                        item.pivot.isr_ret,
                        item.pivot.iva_ret,
                        item.pivot.discount,
                        item.pivot.amount);
                });

            } else {
                console.log('id');
                let arr = id.split('-');
                console.log(arr);
                this.form.serv_id = arr[0];
                this.form.service_type = arr[1];
                if (arr[1] == 1) {
                    console.log('aqqq');

                    const objetoEspecifico = this.cataloguePays.find(item => item.id == arr[0]);
                    concept += objetoEspecifico.name;
                    concept += ` en  ${dateConcept}`;

                    console.log('objetoEspecifico');
                    console.log(objetoEspecifico);

                    this.addJsonItems(
                        data.id,
                        objetoEspecifico.name,
                        1,
                        objetoEspecifico.subtotal,
                        objetoEspecifico.iva,
                        objetoEspecifico.ieps,
                        objetoEspecifico.isr_ret,
                        objetoEspecifico.iva_ret,
                        objetoEspecifico.discount,
                        objetoEspecifico.amount);

                } else {
                    const objetoEspecifico = this.servicesExtras.find(item => item.id == arr[0]);
                    concept += objetoEspecifico.name;
                    concept += ` del mes de ${dateConcept}`;

                    this.addJsonItems(
                        data.id,
                        objetoEspecifico.name,
                        2,
                        objetoEspecifico.pivot.subtotal,
                        objetoEspecifico.pivot.iva,
                        objetoEspecifico.pivot.ieps,
                        objetoEspecifico.pivot.isr_ret,
                        objetoEspecifico.pivot.iva_ret,
                        objetoEspecifico.pivot.discount,
                        objetoEspecifico.pivot.amount);
                }
            }

            if (data.building) {
                if (data.building.address != '' && data.building.address != 'undefined') {
                    concept += `, del inmueble ubicado en ${data.building.address}`;
                }

            }

            if (id == 0) {
                this.addJsonItems(
                    data.id,
                    concept,
                    1,
                    data.subtotal,
                    data.iva,
                    data.ieps,
                    data.isr_ret,
                    data.iva_ret,
                    data.discount,
                    data.amount);
            }


            this.form.concept = concept;
        },
        closedModal() {
            this.form.id = '';
            this.form.type_id = 2;
            this.form.item_id = '';
            this.form.tenant_id = '';
            this.form.number = '';
            this.form.service_id = '';
            this.form.service_type = '';
            this.form.serv_id = '';
            this.form.file = '';
            this.form.concept = '';
            this.form.folio = '';
            this.form.company_id = '';
            this.form.amount = '';
            this.form.xml = '';
            this.send = false;
            this.load = false;
            this.fileName = '';
            this.xmlName = '';
            this.file = '';
            this.xml = '';
            this.tenant = {};
            this.service_type = '';
            this.form.json_items = [];
            this.form.group_bill = 0;

            this.form.payment_method = 'PPD';
            this.form.currency_id = 1;
            this.form.change_date = '';
            this.form.exchange_rate = '';
            this.form.amount_usd = '';
            this.form.from = '';

            this.$modal.hide('addNumberServiceTenant');
        },
        catch_file(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.file = event.target.files[0];
                this.fileName = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        catch_xml(event) {
            console.log(event.target.files[0].type);
            if (event.target.files[0].type == "text/xml") {
                this.form.xml = event.target.files[0];
                this.xmlName = event.target.files[0].name;
                this.catchDataXML(event.target.files[0]);

            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos XML',
                });
            }
        },
        async catchDataXML(file) {
            console.log(file);
            const data_form = new FormData();
            data_form.append('xml', file);

            let _endpoint = `/bill_load_xml`;

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    console.log(data);
                    // if (data.in_month == true) {
                    this.form.folio = data.Folio;
                    this.form.amount = data.Total;

                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {

                    this.errors = await this.errorNotification(error);
                }
            }

        },
        async saveNumberBill() {
            this.send = true;

            const data_form = new FormData();
            data_form.append('id', this.form.id)
            data_form.append('type_id', this.form.type_id)
            data_form.append('tenant_id', this.form.tenant_id)
            data_form.append('service_id', this.form.service_id)
            data_form.append('number', this.form.number)
            data_form.append('file', this.form.file);
            data_form.append('xml', this.form.xml);
            data_form.append('concept', this.form.concept);
            data_form.append('folio', this.form.folio);
            data_form.append('company_id', this.form.company_id);
            data_form.append('amount', this.form.amount);
            data_form.append('service_type', this.form.service_type)

            data_form.append('currency_id', this.form.currency_id);
            data_form.append('change_date', this.form.change_date);
            data_form.append('exchange_rate', this.form.exchange_rate);
            data_form.append('amount_usd', this.form.amount_usd);
            data_form.append('payment_method', this.form.payment_method);
            data_form.append('from', this.form.from);
            data_form.append('json_items', JSON.stringify(this.form.json_items));
            data_form.append('group_bill', this.form.group_bill);

            let _endpoint = '/tenant_service_bill_number';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/tenant_service_bill_number/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-debts');
                    Event.$emit('event-load-month');
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }

        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-addNumberServiceTenants", async (data, type, number) => {

            console.log('tenant');
            console.log(data);
            console.log(type);
            console.log(number);

            
            this.tenant = data;
            if (this.tenant.bill_group) {
                this.form.group_bill = this.tenant.bill_group;
            }

            console.log(this.tenant);
            if (this.tenant.currency_id == 2) {
                this.form.currency_id = data.invoice_issued == 2 ? 1 : 2;
            }
            this.service_type = type;

            this.catalogue.get_companies_buildings(this.tenant.building_id);

            if (data.id) {
                this.cataloguePays = data.services_extras_unavailable;
                this.servicesExtras = data.services_extras;
            }

            this.form.tenant_id = data.id;

            if (number) {
                this.form.id = number.id;
                this.form.tenant_id = number.tenant_id;
                this.form.number = number.number;
                this.form.type_id = 2;
                this.form.concept = number.concept;
                this.form.folio = number.folio;
                this.form.company_id = number.company_id;
                this.form.amount = number.amount;
                this.form.payment_method = number.payment_method;

                if (number.currency_id) {
                    this.form.currency_id = number.currency_id;
                }
                this.form.change_date = number.change_date;
                this.form.exchange_rate = number.exchange_rate;
                this.form.amount_usd = number.amount_usd;

                this.form.json_items = JSON.parse(number.json_items);
                this.form.group_bill = number.group_bill;

                if (number.file) {
                    this.file = number.file;
                }
                if (number.xml) {
                    this.xml = number.xml;
                }

                if (number.service_id == 0) {
                    this.form.service_id = number.service_id;
                } else {
                    this.form.service_id = `${number.service_id}-${number.service_type}`;
                }
            }

            if (type == 'services_extras_unavailable') {
                this.form.type_id = 1;
            }

            this.$modal.show('addNumberServiceTenant');
        }),
        Event.$on("event-show-addNumberServiceTenantsFrom", async (data, type, number) => {
                this.tenant = data;
                console.log(this.tenant);
                this.service_type = type;


                if (data.id) {
                    this.cataloguePays = data.services_extras_unavailable;
                    this.servicesExtras = data.services_extras;
                }

                this.form.tenant_id = data.id;

                this.form.from = number.id;

                console.log('number');
                console.log(number);

                if (number.credit_note) {
                    this.form.id = number.credit_note.id;
                    this.form.tenant_id = number.credit_note.tenant_id;
                    this.form.number = number.credit_note.number;
                    this.form.type_id = 2;
                    this.form.concept = number.credit_note.concept;
                    this.form.folio = number.credit_note.folio;
                    this.form.company_id = number.credit_note.company_id;
                    this.form.amount = number.credit_note.amount;
                    this.form.payment_method = number.credit_note.payment_method;

                    if (number.credit_note.currency_id) {
                        this.form.currency_id = number.credit_note.currency_id;
                    }
                    this.form.change_date = number.credit_note.change_date;
                    this.form.exchange_rate = number.credit_note.exchange_rate;
                    this.form.amount_usd = number.credit_note.amount_usd;
                    this.form.from = number.credit_note.from;
                    this.form.group_bill = number.credit_note.group_bill;

                    if (number.credit_note.file) {
                        this.file = number.credit_note.file;
                    }
                    if (number.credit_note.xml) {
                        this.xml = number.credit_note.xml;
                    }

                    if (number.credit_note.service_id == 0) {
                        this.form.service_id = number.credit_note.service_id;
                    } else {
                        this.form.service_id = `${number.credit_note.service_id}-${number.credit_note.service_type}`;
                    }
                }

                if (type == 'services_extras_unavailable') {
                    this.form.type_id = 1;
                }

                this.$modal.show('addNumberServiceTenant');
            }),
            Event.$on("event-show-addBillServiceTenants", async (tenant, service, type,  pay) => {              
                this.tenant = tenant;

                console.log(service);


                this.service_type = 0;
                if (service.service_id == 0) {
                    this.form.service_id = service.service_id;
                } else {
                    if(service.type == 'services_extras_unavailable'){
                        this.form.service_id = `${service.service_id}-1`;
                    }else{
                        this.form.service_id = `${service.service_id}-2`;
                    } 
                }

                this.service_type = type;


                this.catalogue.get_companies_buildings(this.tenant.building_id);

                if (this.tenant.currency_id == 2) {
                    this.form.currency_id = tenant.invoice_issued == 2 ? 1 : 2;
                }

                if (tenant.id) {
                    this.cataloguePays = tenant.services_extras_unavailable;
                    this.servicesExtras = tenant.services_extras;
                }


                this.form.tenant_id = tenant.id;                
                this.dataPay( this.form.service_id);

                if (pay) {
                    this.form.number = pay.number;
                    this.form.folio = pay.folio;
                    this.form.company_id = pay.company_id;
                    this.form.group_bill = pay.group_bill;
                }

                this.$modal.show('addNumberServiceTenant');

            });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    watch: {
        'form.service_id'(nVal) {
            console.log(nVal);
            if (nVal != '') {
                this.dataPay(nVal);
            }
        },
        'form.json_items'() {
            this.getTotal();
        },
        deep: true
    },

}
</script>
<template>
    <modal name="addNumberServiceTenant" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveNumberBill" method="post" id="formTax" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Agregar número de factura</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <label>Método de pago</label><br>
                                <label class="mr-2">
                                    PPD
                                    <input :disabled="!prop_edit" type="radio" v-model="form.payment_method"
                                        value="PPD">
                                </label>
                                <label class="mr-2">
                                    PUE
                                    <input :disabled="!prop_edit" type="radio" v-model="form.payment_method"
                                        value="PUE">
                                </label>
                                <label>
                                    Sin factura
                                    <input :disabled="!prop_edit" type="radio" v-model="form.payment_method"
                                        value="SIN">
                                </label>
                            </div>
                            <div class="col-md-6 text-right">
                                <label>Factura agrupada</label><br>
                                <label class="mr-2">
                                    Sí
                                    <input :disabled="!prop_edit" type="radio" v-model="form.group_bill" value="1">
                                </label>
                                <label>
                                    No
                                    <input :disabled="!prop_edit" type="radio" v-model="form.group_bill" value="0">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mt-3">
                        <label>Item</label>
                        <select class="form-control" v-model="form.service_id" :disabled="!prop_edit"
                            required="required" v-if="service_type != 'services_extras_unavailable'">
                            <option value="">Selecciona un item</option>
                            <option value="0">
                                Renta
                                <span
                                    v-for="(item_other, index_other) in servicesExtras.filter(item => item.pivot.group_bill != 0)"
                                    :key="index_other">
                                    , {{ item_other.name }}
                                </span>
                            </option>
                            <option v-show="item.pivot.group_bill == 0" :value="`${item.id}-2`"
                                v-for="(item, index) in servicesExtras" :key="index">{{ item.name }}
                            </option>
                        </select>

                        <select class="form-control" v-model="form.service_id" :disabled="!prop_edit"
                            required="required" v-if="service_type == 'services_extras_unavailable'">
                            <option value="">Selecciona un item</option>
                            <option :value="`${item.id}-1`" v-for="(item, index) in cataloguePays" :key="index">{{
                                item.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.service_id" class="text-danger">{{ errors.service_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Número de factura</label>
                        <input class="form-control" v-model="form.number" :disabled="!prop_edit">
                        <div v-if="errors && errors.number" class="text-danger">{{ errors.number[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Empresa</label>
                        <select class="form-control" v-model="form.company_id" :disabled="!prop_edit">
                            <option value="">Sin empresa</option>
                            <option v-for="(company, index) in catalogue.companies_buildings" :key="index" :value="company.id">{{ company.name }}</option>
                        </select>
                            
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Concepto</label>
                        <input class="form-control" v-model="form.concept" :disabled="!prop_edit">
                        <div v-if="errors && errors.concept" class="text-danger">{{ errors.concept[0] }}</div>
                    </div>

                    <!-- <div class="col-md-6 mt-3">
                        <label>PDF</label><br>
                        <div class="custom-file" :style="file != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''" id="customFile" ref="file" @change="catch_file">
                            <label class="custom-file-label text-left" for="customFile">{{ fileName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${file}`" v-if="file != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.file" class="text-danger">{{ errors.file[0] }}</div>

                    </div>
                    <div class="col-md-6 mt-3">
                        <label>XML</label><br>
                        <div class="custom-file" :style="xml != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" id="fileXML" class="custom-file-input"
                                :class="xml != '' ? 'pr-5' : ''" ref="file" @change="catch_xml">
                            <label class="custom-file-label text-left" for="customFile">{{ xmlName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${xml}`" v-if="xml != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.xml" class="text-danger">{{ errors.xml[0] }}</div>
                    </div> -->

                    <div class="col-md-12 mt-3">

                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>CONCEPTO</th>
                                    <th>SUBTOTAL</th>
                                    <th>IVA</th>
                                    <th>IEPS</th>
                                    <th>ISR RET</th>
                                    <th>IVA RET</th>
                                    <th>DESCUENTO</th>
                                    <th>TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in form.json_items" :key="index">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.sub_total | toCurrency }}</td>
                                    <td>{{ item.iva | toCurrency }}</td>
                                    <td>{{ item.ieps | toCurrency }}</td>
                                    <td>{{ item.isr_ret | toCurrency }}</td>
                                    <td>{{ item.iva_ret | toCurrency }}</td>
                                    <td>{{ item.discount | toCurrency }}</td>
                                    <td>{{ item.amount | toCurrency }}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="col-md-12 mt-3">
                        <div class="row justify-content-start">
                            <div class="col-md-3" v-if="tenant.currency_id == 1 && tenant.currency_id == 2"
                                :style="form.currency_id == 2 ? 'padding-top: 30px' : ''">
                                <label v-for="(currency, index) in catalogue.currencies" :key="index" class="ml-1">
                                    {{ currency.name }} <input :disabled="!prop_edit" v-model="form.currency_id"
                                        :value="currency.id" type="radio" name="currency">
                                </label>
                            </div>

                            <!-- USD -->
                            <div :class="tenant.currency_id == 2 ? 'col-md-4' : 'col-md-3'"
                                v-if="form.currency_id == 2">
                                <label> Fecha tipo de cambio </label>
                                <date-picker v-model="form.change_date" :disabled="!prop_edit"
                                    valueType="format"></date-picker>
                                <div v-if="errors && errors.change_date" class="text-danger">{{ errors.change_date[0] }}
                                </div>
                            </div>
                            <div :class="tenant.currency_id == 2 ? 'col-md-4' : 'col-md-3'"
                                v-if="form.currency_id == 2">
                                <label> Tipo de cambio </label>
                                <money :disabled="!prop_edit" class="form-control" v-model="form.exchange_rate"></money>
                                <div v-if="errors && errors.exchange_rate" class="text-danger">{{
                                    errors.exchange_rate[0] }}</div>
                            </div>
                            <div :class="tenant.currency_id == 2 ? 'col-md-4' : 'col-md-3'"
                                v-if="form.currency_id == 2">
                                <label> Monto USD </label>
                                <money :disabled="!prop_edit" :keyup="calcTotalUSD()" class="form-control"
                                    v-model="form.amount_usd"></money>
                                <div v-if="errors && errors.amount_usd" class="text-danger">{{ errors.amount_usd[0] }}
                                </div>
                            </div>


                        </div>
                    </div>


                    <div class="col-md-6 mt-3">
                        <label>Folio</label>
                        <!-- <input class="form-control" :disabled="!prop_edit || form.type_id == 2" v-model="form.folio"> -->
                        <input class="form-control" :disabled="!prop_edit" v-model="form.folio">
                        <div v-if="errors && errors.folio" class="text-danger">{{ errors.folio[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Monto <span v-if="tenant.currency_id == 2 && tenant.invoice_issued == 2">USD</span>
                        </label>
                        <!-- <money :disabled="!prop_edit || form.type_id == 2" class="form-control" v-model="form.amount"> -->
                        <money disabled class="form-control" v-model="form.amount">
                        </money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>


                    <div class="col-md-12">
                        <hr>
                        <button :disabled="send" v-if="prop_edit" type="submit"
                            class="btn float-right btn-outline-success">
                            <spam v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </spam>
                            <spam v-else>
                                <i class="fas fa-save"></i> Guardar
                            </spam>
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>